import { IJsonSheet } from 'json-as-xlsx';

const ASSET_COLUMNS = [
  'frameCode',
  'assetType',
  'addressDetail1',
  'addressDetail2',
  'postcode',
  'latitude',
  'longitude',
  'allotment.sot',
  'price',
  'displayUnitId',
  'digitalPlayerId',
  'iso3CountryCode',
  'districtName',
  'townName',
  'countyName',
  'width',
  'height',
  'motionType',
  'fps',
  'audible',
  'frameImagePath',
  'slotDuration',
  'defaultOffer',
  'channelName',
  'productFormatName',
  'venueTaxonomyEnumerationId',
  'inUse',
];

const AVAILABILITY_COLUMNS = ['frameCode', 'status', 'startDate', 'endDate'];

const TIME_MODEL_COLUMNS = [
  'frameCode',
  'startDate',
  'endDate',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
  'startOffset',
  'endOffset',
];

const TAG_COLUMNS = ['frameCode', 'tagName', 'startDate', 'endDate'];

const PROHIBITIONS_COLUMNS = [
  'frameCode',
  'prohibition.productCategoryCode',
  'prohibitionStartDate',
  'prohibitionEndDate',
  'prohibitionCounter.organisationType',
  'prohibitionCounter.organisationName',
  'counterStartDate',
  'counterEndDate',
];

const ORGANISATIONS_COLUMNS = [
  'organisationName',
  'organisationCode',
  'organisationType',
  'brandName',
  'brandCode',
  'productCategoryCode',
  'inUse',
];

const PRODUCT_CATEGORY_COLUMNS = ['productCategoryCode', 'productCategoryName', 'inUse'];

const BLACKLIST_COLUMNS = ['frameCode', 'organisationType', 'organisationName', 'startDate', 'endDate'];

const TEMPLATE_SHEETS = {
  asset: { title: 'Asset', columns: ASSET_COLUMNS },
  availability: { title: 'Availability', columns: AVAILABILITY_COLUMNS },
  timeModel: { title: 'TimeModel', columns: TIME_MODEL_COLUMNS },
  tag: { title: 'Tag', columns: TAG_COLUMNS },
  prohibitions: { title: 'Prohibitions', columns: PROHIBITIONS_COLUMNS },
  organisations: { title: 'Organisations', columns: ORGANISATIONS_COLUMNS },
  productCategory: { title: 'ProductCategory', columns: PRODUCT_CATEGORY_COLUMNS },
  blacklist: { title: 'Blacklist', columns: BLACKLIST_COLUMNS },
};

export const getV2AssetTemplate = (): IJsonSheet[] =>
  Object.values(TEMPLATE_SHEETS).map(({ title, columns }) => ({
    sheet: title,
    columns: columns.map((column) => ({ label: column, value: column })),
    content: [],
  }));
